import {useState, useEffect} from "react";
import controller from "../services/previewController";

const VideoPreview = ({videoUrl}) => {
  const [previewUrl, setPreviewUrl] = useState(
    "./images/default_thumbnail.png",
  );

  useEffect(() => {
    setPreviewUrl("./images/default_thumbnail.png");

    return controller.withUrl(videoUrl).onPreviewLoaded(setPreviewUrl);
  }, [videoUrl]);

  return (
    <div className="absolute inset-0 bg-black group pointer-events-none">
      <img
        src={previewUrl}
        alt="Video preview"
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover pointer-events-none"
        onError={(e) => {
          e.currentTarget.src = "./images/default_thumbnail.png";
        }}
      />

      <div className="absolute inset-0 bg-black/10 transition-colors group-hover:bg-black/20 pointer-events-none" />

      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="flex h-[52px] w-[52px] items-center justify-center rounded-full bg-black/65 shadow-xl transition-colors duration-200 pointer-events-none">
          <div className="ml-1 h-0 w-0 border-y-[13px] border-y-transparent border-l-[21px] border-l-white pointer-events-none" />
        </div>
      </div>
    </div>
  );
};

export default VideoPreview;
